import axios from "axios";

const getToken = () => {
    // Use sessionStorage instead of localStorage for better security
    // Token will be cleared when browser tab/window is closed
    const storedToken = sessionStorage.getItem("authToken");
    return storedToken || null;
};

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL ?? "",
});

axiosInstance.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
        config.headers = config.headers || {};
        config.headers["x-access-token"] = token;
    }
    return config;
});

export default axiosInstance;
